/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { Address, EntitiesModel, PaginationModel } from '@lm-nx-frontend/lm-inf-core';
import { TableService } from '@lm-nx-frontend/lm-inf-ui';
import { Observable } from 'rxjs';
import { OrganizationTableType } from '../../../../shared/organization.model';
import { SubListService } from '../../../../shared/sub-list/sub-list.service';
import {OrgUnitService} from "../../../../../core/services";

@Injectable({
  providedIn: 'root',
})
export class UnitAddressListService extends SubListService<Address> {
  protected tableType = OrganizationTableType.UNIT_ADDRESS;
  protected _domainType = OrganizationTableType.UNIT_ADDRESS;

  constructor(
    protected tableService: TableService,
    protected orgUnitService: OrgUnitService
  ) {
    super(tableService);
  }

  protected load(
    _pagination: PaginationModel,
    code: string
  ): Observable<EntitiesModel<Address> | undefined> {
    return this.orgUnitService.getAddresses(code);
  }
}
